import { sendEventV2 } from '@/utils/analytics';

export function isTwitchUrl(url: string): boolean {
    return url.includes('twitch.tv/') && !url.includes('clips.twitch.tv');
}

export function extractTwitchChannel(url: string): string | null {
    try {
        const parsed = new URL(url);
        const parts = parsed.pathname.split('/').filter(Boolean);
        return parts[0] || null;
    } catch {
        return null;
    }
}

// Pass watchedSeconds for duration events (heartbeat / watch_time); omit it for discrete events.
export function trackTwitchEngagement(eventType: string, videoUrl: string, watchedSeconds?: number) {
    const numbers = watchedSeconds !== undefined ? [Math.round(watchedSeconds)] : [];
    sendEventV2('video_engagement', [eventType, videoUrl], numbers);
}
